import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlassPlus } from '@fortawesome/pro-regular-svg-icons'

import { DISPLAY_MODE, SectorModalContext } from '../../Providers/Forms/SectorModal'

import '../../assets/shifts-manager.scss'

const SectorLink = ({ sector }) => {
  const { setSelectedSector } = useContext(SectorModalContext)

  const handleClick = () => {
    setSelectedSector({
      data: sector,
      callback: null,
      mode: DISPLAY_MODE
    })
  }

  return (
    <a onClick={handleClick}>
      <div className='flex-row link-style' style={{ alignItems: 'center', gap: '8px' }}>
        <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
        <span>{sector?.name}</span>
      </div>
    </a>
  )
}

export default SectorLink
